<template>
  <transition name="fab">
    <a
      v-show="visible"
      class="wa"
      :href="url"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escribinos por WhatsApp"
    >
      <svg width="34" height="34" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path fill="#ffffff" :d="path" />
      </svg>
    </a>
  </transition>
</template>

<script>
import { whatsappUrl, WHATSAPP_PATH } from '../config';

export default {
  name: 'WhatsappWidget',
  data() {
    return {
      path: WHATSAPP_PATH,
      // Se muestra después de bajar un poco, para no tapar el botón de la portada
      visible: false,
    };
  },
  computed: {
    // https://wa.me funciona en celular y en PC, con o sin la app instalada.
    url() {
      return whatsappUrl();
    },
  },
  methods: {
    onScroll() {
      this.visible = window.scrollY > 240;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
</script>

<style scoped>
.wa {
  position: fixed;
  right: max(20px, env(safe-area-inset-right, 0px));
  bottom: max(20px, env(safe-area-inset-bottom, 0px));
  z-index: 100;
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--whatsapp);
  box-shadow: 0 10px 30px rgba(0, 66, 37, 0.35);
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  transition: transform 0.15s ease;
}

.wa:hover {
  transform: translateY(-3px);
}

.wa::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: var(--whatsapp);
  z-index: -1;
  animation: wapulse 2.4s ease-out infinite;
}

@keyframes wapulse {
  0% { transform: scale(1); opacity: 0.55; }
  100% { transform: scale(1.45); opacity: 0; }
}

.fab-enter-active,
.fab-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fab-enter-from,
.fab-leave-to {
  opacity: 0;
  transform: translateY(12px) scale(0.9);
}

@media (prefers-reduced-motion: reduce) {
  .wa::before {
    animation: none;
  }
}
</style>
